@import 'src/styles/variabels';
@import 'src/styles/mobile';

.button {
  border: 1px solid $color-secondary;
  &Active {
    cursor: default;
    box-shadow: none;
    &:hover {
      box-shadow: none;
    }
  }
}

// N2 (T1): below md the selected segment of a segmented control or a view
// switch is the theme's primary tint, not the slate fill; the others keep
// their outline. Doubled: MUI's contained rules are one class deep.
@media (max-width: map-get($breakpoints, 'md') - 1 + px) {
  .button.buttonActive {
    @include mobile-segment-selected;
  }
}
